import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const Footer = () => {
  const [blocks, setBlocks] = useState({});
  const location = useLocation();

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const response = await axios.get(`${API_BASE}/site-blocks`);
        setBlocks(response.data);
      } catch (err) {
        console.log('Could not load footer blocks');
      }
    };
    fetchBlocks();
  }, []);

  // Home page uses a dedicated left block (so the web-studio href can be
  // hardcoded inside that block); every other page uses the standard one.
  const leftBlockHtml = location.pathname === '/'
    ? (blocks.footer_below_left_home || blocks.footer_below_left || '')
    : (blocks.footer_below_left || '');

  return (
    <footer data-testid="site-footer">
      <div className="border-t border-gray-200 bg-gray-50 py-10 px-0 md:px-4 lg:px-8">
        <div className="max-w-full md:max-w-[70%] mx-auto flex flex-col md:flex-row items-center md:items-start md:justify-between space-y-6 md:space-y-0 px-4 md:px-0">
          <div
            className="footer-below-left"
            dangerouslySetInnerHTML={{ __html: leftBlockHtml }}
            data-testid="footer-below-left"
          />
          <div
            className="footer-below-right"
            dangerouslySetInnerHTML={{ __html: blocks.footer_below_right || '' }}
            data-testid="footer-below-right"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
